import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SalesforceEntityIconComponent } from 'entity-icon-lib';
import { normalizeHexColor } from 'icon-service-lib';
import { IEntityTypeCount, IIconService } from 'interfaces-lib';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IdentityStorage } from 'storage-service-lib';

@Component({
  selector: 'app-entity-toggle-group',
  imports: [CommonModule, MatButtonToggleModule, MatTooltipModule, MatIconModule, SalesforceEntityIconComponent],
  templateUrl: './entity-toggle-group.component.html',
  styleUrl: './entity-toggle-group.component.scss',
})
export class EntityToggleGroupComponent {
  @Input() set entityTypesUsed(entityTypesUsed: IEntityTypeCount[]) {
    this._entityTypesUsed = entityTypesUsed;
    this.total = this.calculateTotal(entityTypesUsed);
  }
  @Input() totalOverride: number | undefined = undefined;
  @Input() currentEntityFilter: string | undefined;
  @Input() value: string | undefined;

  @Output() onFilterChange = new EventEmitter<string>();

  _entityTypesUsed!: IEntityTypeCount[];
  total!: number;
  iconService: IIconService;

  constructor(private serviceProviderFactory: SharedServiceProviderServiceFactory, private identityStorage: IdentityStorage) {
    this.iconService = this.serviceProviderFactory.getServiceProviderService(this.identityStorage.get()?.namespace).getIconService();

  }

  getEntityColor(entity: IEntityTypeCount): string | null {
    return normalizeHexColor(entity?.iconColor);
  }

  private calculateTotal(entityTypesUsed: IEntityTypeCount[]): number {
    return entityTypesUsed.reduce((sum, entityType) => sum + entityType.count, 0);
  }
}
